<template>
    <div>
        <DxDataGrid
                class="dx-card wide-card"
                :selection="{ mode: 'single' }"
                :data-source="dataSourceConfig"
                :focused-row-index="0"
                :show-borders="true"
                :focused-row-enabled="true"
                :column-auto-width="true"
                :column-hiding-enabled="true"
                key-expr="tageId"
        >
<!--            <DxPaging :enabled="false"/>-->
<!--            <DxEditing-->
<!--                    :allow-updating="true"-->

<!--                    mode="popup">-->
<!--            </DxEditing>-->
            <!--加载框-->
            <DxLoadPanel :enabled="true" />
            <dx-paging :page-size="10" />
            <dx-pager :show-page-size-selector="true" :show-info="true" />
            <dx-filter-row :visible="true" />

            <DxColumn data-field="Task_ID" :width="90" :hiding-priority="2" />

            <DxColumn
                    data-field="app_name"
                    caption="公众号"
                    :width="190"
                    :hiding-priority="8"
            />

            <DxColumn
                    data-field="name"
                    caption="标签"
                    :hiding-priority="6"
            />
            <!--                    data-type="date"-->
            <DxColumn
                    data-field="create_time"
                    caption="创建时间"
                    :hiding-priority="3"
                    sort-order="asc"
            />
            <DxColumn
                    data-field="count"
                    caption="关注人数"
                    :hiding-priority="6"
                    :width="100"
                    sort-order="asc"
            />
<!--            <DxColumn-->
<!--                    data-field="tagsCount"-->
<!--                       caption="操作"-->
<!--                       :hiding-priority="6"-->
<!--                       :width="100"-->
<!--                    @click="selectMessage"-->
<!--            ></DxColumn>-->

        </DxDataGrid>
    </div>
</template>

<script>
    import "devextreme/data/odata/store";
    import DxDataGrid, {
        DxColumn,
        DxFilterRow,
        DxLookup,
        DxPager,
        DxPaging
    } from "devextreme-vue/data-grid";

    const priorities = [
        { name: "High", value: 4 },
        { name: "Urgent", value: 3 },
        { name: "Normal", value: 2 },
        { name: "Low", value: 1 }
    ];
    export default {
        data() {
            return {
                priorities,
                events : [],
                dataSourceConfig : [],
                textBoxOptions: {
                    placeholder: 'Search...',
                    showClearButton: true
                },
                searchButtonOptions: {
                    icon: 'search',
                    onClick: () => {
                        this.showMessage('Search');
                    }
                }
            };
        },
        created() {
            this.$http.get_allTags(null).then(res =>{
                this.dataSourceConfig = res.data
            })

        },
        components: {
            DxDataGrid,
            DxColumn,
            DxFilterRow,
            DxLookup,
            DxPager,
            DxPaging
        },
        methods:{
            showMessage(name) {
                notify(
                    {
                        message: `${name} button has been clicked!`,
                        width: 300
                    },
                    'info',
                    500
                );
            }
        }
    };
</script>
